<mat-card>
  <mat-card-header>
    <mat-card-title style="text-align: center">
      {{ 'settings.contact-and-help.ccab' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="content">
    <mat-list>
      <ng-container *ngFor="let contact of contacts">
        <mat-divider class="divider-spacing-buttom"></mat-divider>
        <mat-list-item>
          <mat-icon class="custom-margin" mat-list-icon>place</mat-icon>
          <div mat-line class="item">
            <h2 class="title">{{ contact.address.location | translate }}</h2>
          </div>
          <p mat-line class="item">
            {{ contact.address.address | translate }}
          </p>
        </mat-list-item>

        <mat-list-item>
          <mat-icon class="custom-margin" mat-list-icon>phone</mat-icon>
          <div mat-line class="item">
            <h2 class="title">{{ 'marketplace.dialog.contact' | translate }}</h2>
          </div>
          <div *ngFor="let phone of contact.phones" mat-line class="item">
            <span> {{ 'settings.contact-and-help.phone' | translate }}: </span>
            <a [href]="'tel:' + phone">{{ phone }}</a>
          </div>
        </mat-list-item>
      </ng-container>
      <mat-divider class="divider-spacing-buttom"></mat-divider>
      <div class="d-flex flex-column">
        <mat-list-item>
          <mat-icon mat-list-icon>place</mat-icon>
          <div mat-line class="item">
            <h2 class="title">{{ 'settings.contact-and-help.address.brasilia.location' | translate }}</h2>
          </div>
          <p mat-line class="item">
            {{ 'settings.contact-and-help.address.brasilia.address' | translate }}
          </p>
        </mat-list-item>

        <mat-list-item>
          <mat-icon class="custom-margin" mat-list-icon>phone</mat-icon>
          <div mat-line class="item">
            <h2 class="title">{{ 'marketplace.dialog.contact' | translate }}</h2>
          </div>
          <div *ngFor="let phone of brasilia.phones" mat-line class="item">
            <span> {{ 'settings.contact-and-help.phone' | translate }}: </span>
            <a [href]="'tel:' + phone">{{ phone }}</a>
          </div>
        </mat-list-item>
      </div>

      <mat-divider></mat-divider>
      <mat-list-item>
        <p mat-line class="text-upper"></p>
        <p mat-line></p>
        <p mat-line></p>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
